import { ConflictChangeSetError, IChangeSetManager } from "../../Engine/Core/ChangeSet/IChangeSetManager";

export function setupOnLeavePageHandler(changeSet: IChangeSetManager): void {
    window.addEventListener("beforeunload", event => {
        try {
            changeSet.sendSync();
        } catch (e) {
            if (e instanceof ConflictChangeSetError) {
                return undefined;
            }
            const confirmationMessage = "Часть изменений не сохранена. Остаться на странице?";
            // Gecko, Trident, Chrome 34+
            event.returnValue = confirmationMessage;
            // Gecko, WebKit, Chrome <34
            return confirmationMessage;
        }
        return undefined;
    });
}
